/* Reuse Kalles' delegated drawer handler and its existing sidebar loader. */
if (!customElements.get('collection-sidebar-button')) {
  customElements.define('collection-sidebar-button', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.openedByButton = false;
      this.onClick = () => { this.openedByButton = true; };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.sync());
      // The drawer is fetched asynchronously and replaced by theme editor updates.
      this.observer.observe(document.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden']
      });
      this.sync();
    }

    sync() {
      const source = document.querySelector('.t4s-section-sidebar [data-sidebar-id]');
      const id = source && source.getAttribute('data-sidebar-id');
      const drawer = id && document.getElementById(`drawer-${id}`);
      this.toggleAttribute('data-inline-sidebar', !!source && source.hasAttribute('data-sidebar-false'));
      this.button.disabled = !drawer;
      if (!drawer) {
        this.button.removeAttribute('data-drawer-options');
        this.button.removeAttribute('aria-controls');
        this.button.setAttribute('aria-expanded', 'false');
        return;
      }
      this.button.setAttribute('data-drawer-options', JSON.stringify({ id: `#${drawer.id}` }));
      this.button.setAttribute('aria-controls', drawer.id);
      const expanded = drawer.getAttribute('aria-hidden') === 'false';
      const wasExpanded = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', String(expanded));
      if (wasExpanded && !expanded && this.openedByButton) {
        this.button.focus({ preventScroll: true });
        this.openedByButton = false;
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.button) this.button.removeEventListener('click', this.onClick);
    }
  });
}
